import slide1 from './assets/architecture-1.webp';
import slide2 from './assets/architecture-2.webp';
import slide3 from './assets/architecture-3.webp';
import slide4 from './assets/architecture-4.webp';
import slide41 from './assets/architecture-5.webp';
import slide42 from './assets/architecture-6.webp';
import slide5 from './assets/landscaping-1.webp';
import slide6 from './assets/landscaping-2.webp';
import slide7 from './assets/landscaping-3.webp';
import slide8 from './assets/landscaping-4.webp';
import slide9 from './assets/landscaping-5.webp';
import slide10 from './assets/halls-1.webp';
import slide11 from './assets/halls-2.webp';
import slide12 from './assets/halls-3.webp';
import slide13 from './assets/halls-4.webp';
import slide14 from './assets/halls-5.webp';
import slide15 from './assets/finishing-1.webp';
import slide16 from './assets/finishing-2.webp';
import slide17 from './assets/finishing-3.webp';
import slide18 from './assets/finishing-4.webp';

export const galleryContent = {
  title: 'галерея проекта',
  titleRight: 'ход строительства',
  months: [
    { label: 'апрель 2026', href: 'https://online.sbis.ru/shared/disk/aa92c2a1-213b-4bec-b4b7-e5bf6b486c71' },
    { label: 'март 2026', href: 'https://online.sbis.ru/shared/disk/3dde48dc-858c-48db-aa46-aa8d86e5f73d' },
    { label: 'февраль 2026', href: 'https://online.sbis.ru/shared/disk/ac84325c-fa70-4527-9021-1d9e33d1e2cb' },
    { label: 'январь 2026', href: 'https://online.sbis.ru/shared/disk/29be9bce-6501-4c1e-a304-07dd1977f3a5' },
    { label: 'декабрь 2025', href: 'https://online.sbis.ru/shared/disk/79fa7e98-3565-4ab1-830d-52e0f0c976c0' },
  ],
  tabs: [
    {
      label: 'архитектура',
      images: [slide1, slide2, slide3, slide4, slide41, slide42],
    },
    {
      label: 'благоустройство',
      images: [slide5, slide6, slide7, slide8, slide9],
    },
    {
      label: 'холлы',
      images: [slide10, slide11, slide12, slide13, slide14],
    },
    {
      label: 'отделка',
      images: [slide15, slide16, slide17, slide18],
    },
  ],
};
